import {clsx} from 'clsx'

import {DropdownCaret} from '../../common/dropdown-caret'
import {BaseCell} from './base-cell'
import styles from './dropdown-cell.module.css'

export const DropdownCell = ({
  ref,
  children,
  isDisabled,
  className,
}: React.PropsWithChildren<{isDisabled?: boolean; className?: string}> & {
  ref?: React.Ref<HTMLButtonElement>
}) => {
  return (
    <BaseCell disallowSelection className={clsx(styles.BaseCell, className)}>
      {children}
      {isDisabled ? null : <DropdownCaret ref={ref} />}
    </BaseCell>
  )
}

DropdownCell.displayName = 'DropdownCell'
